import { render, staticRenderFns } from "./individualAnalysis.vue?vue&type=template&id=53f649bf&scoped=true"
import script from "./individualAnalysis.vue?vue&type=script&lang=js"
export * from "./individualAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f649bf",
  null
  
)

export default component.exports